import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";

@Component({
    selector: 'confirmation-dialog',
    templateUrl: 'confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfirmationDialog {
    constructor(
        public dialogRef: MatDialogRef<ConfirmationDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    public confirm(event?: Event) {
        this.dialogRef.close(true);
        event?.stopPropagation();
    }

    public cancel(event?: Event) {
        this.dialogRef.close(false);
        event?.stopPropagation();
    }

    public static open(dialogs: MatDialog, action: string, description: string, success: Function, restoreFocus: boolean = true) {
        const modal = dialogs.open(ConfirmationDialog, {
            data: {
                action,
                description
            },
            restoreFocus
        });
        const observer = modal.afterClosed();
        observer.forEach(result => {
            if (result == true) {
                success();
            }
        })
    }
}